const menu = document.querySelector('.header .menus_wrapper')
const menuBurger = document.querySelector('.header .menu_btn_burger')
const allSubmenus = menu.querySelectorAll('.sub-menu')

if (menu && menuBurger) {
  menuBurger.onclick = (e) => {
    e.preventDefault()

    toggleMenu()
    toggleSubmenu()
  }
}

const closeAllSubmenus = () => {
  allSubmenus.forEach(sub => sub.style.display = 'none')
}

const openMenu = () => {
  menuBurger.classList.add('open')
  menu.classList.add('open')
  window.document.body.classList.add('responsive_menu_open')
}

const closeMenu = () => {
  menuBurger.classList.remove('open')
  menu.classList.remove('open')
  window.document.body.classList.remove('responsive_menu_open')
  closeAllSubmenus()
}

const toggleMenu = () => {
  if (menuBurger.classList.contains('open')) {
    closeMenu()
  } else {
    openMenu()
  }
}


const toggleSubmenu = () => {
  const listItems = menu.querySelectorAll('#menu-primary > li.menu-item-has-children');

  listItems.forEach(li => {
    li.onclick = () => {
      closeAllSubmenus()
      const currentSubmenu = li.querySelector('.sub-menu')
      currentSubmenu.style.display = 'block';
    }

  });
}



// WEBPACK FOOTER //
// ./scripts/menu.js